export default "__VITE_ASSET__BYibgTvd__"